import { getTopTaalUserQuery } from "@/api/queries/toptaalUsers/useTopTaalUser"
import { FormStyle } from "toptaal-shared"
import TeachingQualificationsForm from "@/pages/onboarding/forms/TeachingQualificationsForm"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"

export const Route = createFileRoute(
  "/beheer/medewerkers/$userId/lesbevoegdheid/controleren",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function RouteComponent() {
  const { userId } = useParams({
    from: "/beheer/medewerkers/$userId/lesbevoegdheid/controleren",
  })

  const { data } = useSuspenseQuery(getTopTaalUserQuery(Number(userId)))

  return (
    <FormStyle className="mx-auto">
      <TeachingQualificationsForm
        user={data.data}
        type="view"
        formTitle={`
          Lesbevoegdheid controleren voor ${data.data.firstName}
        ${data.data.lastName}
        `}
      />
    </FormStyle>
  )
}
